export function getDiscount(model = {}) {
  const discountType = model?.discountType === 'percent' ? 'percent' : (model?.discountType === 'amount' ? 'amount' : 'none');
  const raw = Number(model?.discountValue);
  const discountValue = Number.isFinite(raw) && raw > 0 ? raw : 0;
  return { discountType, discountValue };
}

export function calculateDocumentTotals(model = {}, options = {}) {
  const isSmallBusiness = !!options.isSmallBusiness;
  const includeReminderFee = !!options.includeReminderFee;
  const items = Array.isArray(model?.items) ? model.items : [];

  const lineItems = items.map((item) => {
    const quantity = Number(item?.quantity) || 0;
    const price = Number(item?.price) || 0;
    const lineBase = quantity * price;
    const lineDiscountPercent = Math.max(0, Math.min(100, Number(item?.discountPercent) || 0));
    const net = lineBase * (1 - (lineDiscountPercent / 100));
    let rate = isSmallBusiness ? 0 : (Number(item?.taxRate) >= 0 ? Number(item.taxRate) : 0.19);
    if (rate > 1 && rate <= 100) rate /= 100;
    rate = Math.max(0, Math.min(1, rate));
    return { net, rate };
  });

  const subtotalNet = lineItems.reduce((acc, i) => acc + i.net, 0);
  const { discountType, discountValue } = getDiscount(model);
  const subtotalAbs = Math.abs(subtotalNet);
  const subtotalSign = subtotalNet >= 0 ? 1 : -1;
  let discountAbs = 0;
  if (discountType === 'percent') discountAbs = subtotalAbs * (discountValue / 100);
  if (discountType === 'amount') discountAbs = discountValue;
  discountAbs = Math.max(0, Math.min(subtotalAbs, discountAbs));
  const discountNet = discountAbs * subtotalSign;

  const reminderFee = includeReminderFee ? (Number(model?.reminderFee) || 0) : 0;
  const netAfterDiscount = subtotalNet - discountNet;

  const taxByRate = {};
  if (subtotalAbs > 0) {
    lineItems.forEach((line) => {
      const share = Math.abs(line.net) / subtotalAbs;
      const proportionalDiscount = discountNet * share;
      const discountedNet = line.net - proportionalDiscount;
      const tax = discountedNet * line.rate;
      const key = Math.round(line.rate * 100);
      taxByRate[key] = (taxByRate[key] || 0) + tax;
    });
  }

  const taxTotal = Object.values(taxByRate).reduce((a, b) => a + b, 0);
  const totalNet = netAfterDiscount + reminderFee;
  const totalGross = totalNet + taxTotal;

  return {
    subtotalNet,
    discountType,
    discountValue,
    discountNet,
    reminderFee,
    totalNet,
    taxByRate,
    taxTotal,
    totalGross,
  };
}
